<template>
  <div id="hrms31e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :unLoadBool="true"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHrms31eIndex"
            :editEvent="editEvent"
            searchBoxAlias="hrms31e"
            :callSearchEvent="callSearchEvent" />

    <detail v-show="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :indexSelected="indexSelected"
            :detail="detail"
            :popupDetail="popupDetail"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :pcDisp="pcDisp"
            :dropdowns="dropdowns"
            :postHrms31eSave="postHrms31eSave"
            :postHrms31eDelete="postHrms31eDelete"
            :receivedHrms31eDetailSearch="receivedHrms31eDetailSearch"
            :receivedHrms31eDetailPopup="receivedHrms31eDetailPopup"
            :receivedHrms31eIndex="receivedHrms31eIndex"
            :tab3Table1="columns[app.nowLang].columnsTab3Table1"
            :tab3Table2="columns[app.nowLang].columnsTab3Table2"
            :saveButtonDisp="saveButtonDisp"
            :setSaveButtonDisp="setSaveButtonDisp"
            :codeval="codempid"
            :searchIndex="searchIndex"
            :descCodeval="app.currentUser.username[app.nowLang]"
            :postHrms31eSendMail="postHrms31eSendMail" />
  </div>

</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms31e/mutation-types'
import detail from 'components/hrms31e/detail'
import moment from 'moment'

export default {
  name: 'hrms31e',
  data () {
    return {
      searchParams: {},
      searchIndex: {
        codcomp: '',
        dtestrt: moment().format('DD/MM/YYYY'),
        dteend: moment().format('DD/MM/YYYY'),
        codempstapp: ''
      },
      app: this.$parent.$parent.$parent
    }
  },
  created () {
    this.receivedHrms31eColumnsLabels()
    this.receivedHrms31eDropdowns()
  },
  computed: {
    pcDisp () {
      return this.app.pcDisp
    },
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS31E_INDEX_DISP,
      detailDisp: types.GET_HRMS31E_DETAIL_DISP,
      columns: types.GET_HRMS31E_COLUMNS,
      labels: types.GET_HRMS31E_LABELS,
      index: types.GET_HRMS31E_INDEX,
      indexSelected: types.GET_HRMS31E_INDEX_SELECTED,
      detail: types.GET_HRMS31E_DETAIL,
      dropdowns: types.GET_HRMS31E_DROPDOWNS,
      detailSearch: types.GET_HRMS31E_DETAIL_SEARCH,
      saveButtonDisp: types.GET_HRMS31E_SAVE_BUTTON_DISP,
      popupDetail: types.GET_HRMS31E_DETAIL_POPUP
    })
  },
  methods: {
    pageDetail (event) {
      switch (event) {
        case 'edit':
          if (this.indexSelected.numseq) {
            this.currentDtereq = this.indexSelected.dtereq
            let searchParams = {
              p_codempid_query: this.indexSelected.codempid,
              p_dteduepr: this.indexSelected.dteduepr,
              p_numseq: this.indexSelected.numseq,
              p_dtest: this.indexSelected.dteoccup
            }
            this.receivedHrms31eDetail(searchParams)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    callSearchEvent () {
      if (this.searchIndex.codempstapp !== '') {
        this.searchIndex.codcomp = ''
        this.searchIndex.dtestrt = ''
        this.searchIndex.dteend = ''
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS31E_INDEX_SELECTED,
      setSaveButtonDisp: types.SET_HRMS31E_SAVE_BUTTON_DISP
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS31E_PAGE,
      receivedHrms31eColumnsLabels: types.RECEIVED_HRMS31E_COLUMNS_LABELS,
      receivedHrms31eIndex: types.RECEIVED_HRMS31E_INDEX,
      receivedHrms31eDetail: types.RECEIVED_HRMS31E_DETAIL,
      receivedHrms31eDetailSearch: types.RECEIVED_HRMS31E_DETAIL_SEARCH,
      postHrms31eSave: types.POST_HRMS31E_SAVE,
      postHrms31eCancel: types.POST_HRMS31E_CANCEL,
      postHrms31eDelete: types.POST_HRMS31E_DELETE,
      postHrms31eSendMail: types.POST_HRMS31E_SEND_MAIL,
      receivedHrms31eDropdowns: types.RECEIVED_HRMS31E_DROPDOWNS,
      receivedHrms31eDetailPopup: types.RECEIVED_HRMS31E_DETAIL_POPUP
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?6c25c8c5